module.exports = function () {
    var $header = $('.pulsepoint-header');

    if ($header.length) {
        var previousScrollPosition = -1;
        var forceRefresh = false;

        $(window).resize(function () {
            forceRefresh = true;
        });

        var checkPosition = function () {
            var scrollPosition = $(window).scrollTop();

            if (!forceRefresh && scrollPosition === previousScrollPosition) {
                return;
            }

            forceRefresh = false;
            previousScrollPosition = scrollPosition;

            var headerTransitionPosition = $('.pulsepoint-header-spacer').height();

            if (scrollPosition <= headerTransitionPosition) {
                if ($header.hasClass('pulsepoint-header-sticky')) {
                    $header.removeClass('pulsepoint-header-sticky');
                }
            } else {
                if (!$header.hasClass('pulsepoint-header-sticky')) {
                    $header.addClass('pulsepoint-header-sticky');
                }
            }

            if (scrollPosition < 475) {
                $('.hero-overlay').removeClass('hero-overlay-sticky');
            } else {
                $('.hero-overlay').addClass('hero-overlay-sticky');
            }

            var $element = ICF.Utils.ElementAtPointInElement($(window).width() / 2, 95, $("body"), '[data-anchor-tag]');

            var activeClass = 'pulsepoint-header-nav-active';
            $header.find('.' + activeClass).removeClass(activeClass);

            if ($element.length) {
                var $anchorTag = $element.find('[data-anchor-tag]');

                if ($anchorTag.length) {
                    var anchorTagText = $anchorTag.data('anchorTag');
                    var $headerElement = $header.find('a[href="#' + anchorTagText + '"]');


                    if ($headerElement.length) {
                        $headerElement.parent().addClass(activeClass);
                    }
                }
            } else {
                $header.find('.' + activeClass).removeClass(activeClass);
            }
        };

        setInterval(checkPosition, 50);
    }
};